import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function StatsAbout() {
  const stats = [
    { value: siteInfo.stats.totalComics, label: '漫画资源', icon: 'ri-book-read-line' },
    { value: siteInfo.stats.dailyUpdate, label: '每日更新', icon: 'ri-flashlight-line' },
    { value: siteInfo.stats.totalUsers, label: '漫迷选择', icon: 'ri-user-heart-line' },
    { value: siteInfo.stats.avgRating, label: '用户评分', icon: 'ri-star-line' },
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-primary-900 to-primary-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1">
            <span className="inline-block text-accent-300 text-xs font-medium bg-primary-800/50 px-3 py-1.5 rounded-full mb-4 font-label">
              / 关于073漫画网
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading leading-tight">
              海量韩漫资源
              <br />
              极速更新体验
            </h2>
            <p className="mt-5 text-primary-200 text-sm md:text-base leading-relaxed max-w-lg">
              {siteInfo.description}
            </p>
            <Link
              to="/about"
              className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-700 font-semibold rounded-full hover:bg-background-100 transition-colors text-sm whitespace-nowrap cursor-pointer"
            >
              了解我们
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex-1 w-full">
            <div className="relative rounded-xl overflow-hidden bg-primary-800/30 p-1">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20comic%20reading%20platform%20interface%20on%20laptop%20screen%2C%20Korean%20webtoon%20style%20display%2C%20warm%20ambient%20lighting%2C%20clean%20UI%20design%2C%20cozy%20reading%20atmosphere%2C%20soft%20bokeh%20background%2C%20editorial%20photography%20style%2C%20warm%20tone&width=800&height=600&seq=about-platform&orientation=landscape"
                alt="073漫画网平台界面"
                title="073漫画网 - 韩国漫画在线阅读平台"
                className="w-full h-auto rounded-lg"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-800/50 text-accent-400 mb-3">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-extrabold font-label">{stat.value}</div>
              <div className="text-primary-300 text-sm mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}